import React from 'react';
import ReactDOM from 'react-dom/client';
// layers.css must be imported before any other stylesheet, and must stay its
// own file: webpack hoists the content of an @import above the inline CSS that
// follows it in the same file, so an @layer order declared at the top of
// index.css would land after the stylesheets it is meant to be ordering and
// quietly do nothing. See the comment in layers.css.
import './layers.css';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

